import React, { useEffect, useState } from 'react'
import { Card, Grid,  Stack, TextField, DialogTitle, IconButton } from '@mui/material'
import MDButton from 'components/MDButton'
import { useNavigate } from 'react-router-dom';
import {  openSnackbar } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { isValidNumber } from 'utilities/common';
import { addPromoData, editPromoData } from '../../redux/slices/metrc';

export default function AddMetrcData({ closeModal }) {
    const dispatch = useDispatch()
    const { loading: isBtnLoading = false } = useSelector(state => state?.metrc)
    const [errors, setErrors] = useState({})
    const { modalData } = useSelector(state => state.modal);
    const { type, title, data, edit, metrcHandler = () => { } } = modalData || {};

    const [formData, setFormData] = useState({
        promoAmount: '',
        promoPerentage: ''
    })

    const validateReasons = () => {
        let isError = false
        let errors = {}
        if(type ==='Promotion' ){
            if (!formData?.promoAmount) {
                isError = true
                errors = { ...errors, promoAmount: `Promo Discount is required` }
            }
            if (!formData?.promoPerentage) {
                isError = true
                errors = { ...errors, promoPerentage: `Orders Coverage is required` }
            }
        }
       else if(type ==='Reward' ){
            if (!formData?.promoAmount) {
                isError = true
                errors = { ...errors, promoAmount: `Reward Amount is required` }
            }
            if (!formData?.promoPerentage) {
                isError = true
                errors = { ...errors, promoPerentage: `Orders Coverage is required` }
            }
        }
        else if(type ==='Member' ){
            if (!formData?.promoAmount) {
                isError = true
                errors = { ...errors, promoAmount: `Member Discount is required` }
            }
            if (!formData?.promoPerentage) {
                isError = true
                errors = { ...errors, promoPerentage: `${type} Percentage is required` }
            }
        }
        else{
            if (!formData?.promoAmount) {
                isError = true
                errors = { ...errors, promoAmount: `${type} Amount is required` }
            }
            if (!formData?.promoPerentage) {
                isError = true
                errors = { ...errors, promoPerentage: `${type} Percentage is required` }
            }
        }
        return { errors, isError }
    }

    const submitHandler = () => {
        const { isError, errors } = validateReasons()
        setErrors(errors)
        if (isError) return;
        setErrors({})
        const payload = {}
        if (type === 'Reward') {
            payload.rewardAmount = Number(formData?.promoAmount);
            payload.rewardPercentage = Number(formData?.promoPerentage);
        }
        else if (type === 'Promotion') {
            payload.promoAmount = Number(formData?.promoAmount);
            payload.promoPerentage = Number(formData?.promoPerentage);
        }
        else if (type === 'Member') {
            payload.memberDiscountValue = Number(formData?.promoAmount);
            payload.memberDiscountPercentage = Number(formData?.promoPerentage);
        }
        else { }
        if (edit) {
            const id = type === 'Promotion' ? data?.promoUniqueId : type === 'Reward' ? data?.rewardUniqueId : type === 'Member' ? data?.memberTaxUniqueId : ""
            dispatch(editPromoData({ data: payload, id, type }))
                .unwrap()
                .then(res => {
                    closeModal()
                    metrcHandler();
                    showResponseMessage(res?.message, 'success');
                })
                .catch(err => {
                    showResponseMessage(err?.message, 'error');
                });
        } else {

            dispatch(addPromoData({ data: payload, type }))
                .unwrap()
                .then(res => {
                    closeModal()
                    // dispatch(getPromotionList())
                    metrcHandler();
                    showResponseMessage(res?.message, 'success');
                })
                .catch(err => {
                    showResponseMessage(err?.message, 'error');
                });
        }
    }

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    useEffect(() => {
        if (type === 'Promotion') {
            setFormData((prevData) => ({
                ...prevData,
                promoAmount: data?.promoAmount || '',
                promoPerentage: data?.promoPerentage || ''
            }))
        }
        else if (type === 'Reward') {
            setFormData((prevData) => ({
                ...prevData,
                promoAmount: data?.rewardAmount || '',
                promoPerentage: data?.rewardPercentage || ''
            }))
        }
        else if (type === 'Member') {
            setFormData((prevData) => ({
                ...prevData,
                promoAmount: data?.memberDiscountValue || '',
                promoPerentage: data?.memberDiscountPercentage || ''
            }))
        }
        else {
            setFormData({
                promoAmount: '',
                promoPerentage: ''
            })
        }
    }, [data])
    

    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4, px: 0 }} display='flex' alignItems='center' justifyContent='space-between' style={{ paddingLeft: '0', paddingRight: '0' }}>
                {title} Discount
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>

            <Grid container alignItems='center' spacing={{ xs: 3, md: 3 }} mb={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <TextField
                        InputProps={{
                            // startAdornment: formData?.promoAmount ? '$' : "",
                            startAdornment: type !== 'Promotion' && formData?.promoAmount ? '$' : null,
                            endAdornment: type === 'Promotion' && formData?.promoAmount ? '%' : null,
                        }}
                        className="form-input currency-field"
                        fullWidth
                        label={type === 'Member' ? "Member Discount(%) " : type === 'Promotion' ? "Promo Discount(%)*" : "Reward Amount($)*"}
                        name="promoAmount"
                        value={formData?.promoAmount || ''}
                        error={Boolean(errors?.promoAmount)}
                        helperText={errors?.promoAmount}
                        onChange={(e) => {
                            if (e.target.value && !isValidNumber(e.target.value)) return;
                            setFormData({ ...formData, promoAmount: e.target.value });
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextField
                        InputProps={{
                            endAdornment: formData?.promoPerentage ? '%' : "",
                        }}
                        className="form-input currency-field"
                        fullWidth
                        label={type === 'Member' ? "Member Percentage(%)" : type === 'Promotion' ? "Orders Coverage(%)*" : "Orders Coverage(%)*"}
                        name="promoPerentage"
                        value={formData?.promoPerentage || ''}
                        error={Boolean(errors?.promoPerentage)}
                        onChange={(e) => {
                            if (e.target.value && !isValidNumber(e.target.value)) return;
                            setFormData({ ...formData, promoPerentage: e.target.value });
                        }}
                        helperText={errors?.promoPerentage}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={1}>
                        <MDButton sx={{ minWidth: '160px' }} type='button' variant='contained' color='primary' onClick={() => submitHandler()} disabled={isBtnLoading} loading={isBtnLoading}>
                            {edit ? 'Update ' : 'Save'}
                        </MDButton>
                        <MDButton sx={{ minWidth: '160px' }} type='button' variant='outlined' color='dark' className='dark-outlined-btn' onClick={() => closeModal()}>
                            Cancel
                        </MDButton>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}